import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NoRouteComponent } from '../../modules/shared/components/no-route/no-route.component';
import { AwsAuthService } from '../../services/aws-auth.service';
import { LanguageService } from '../../services/language.service';
import { TranslationService } from '../../services/translation.service';


@Component({
    selector: 'app-main-page',
    templateUrl: './main-page.component.html',
    styleUrls: ['./main-page.component.scss'],
    imports: [TranslateModule, CommonModule, NoRouteComponent],
    standalone: true
})
export class MainPageComponent implements OnInit {
  highlightRegionContainer: any;
  parentContainer: any;
  logstatus: any;
  currentUser: any;
  translationData = [];
  languageId: string|null;
  isPageNotFound = false;
  language = '';
  participantDataToAnonymize: any;
  isProd:boolean = false;
  videoSrc = ''
  bgVideoClass = '';
  constructor(private readonly router: Router,
    private readonly route: ActivatedRoute, private readonly awsAuth: AwsAuthService,
    private readonly translationService: TranslationService, private readonly languageService: LanguageService) {
    this.languageId = this.route.snapshot.paramMap.get('languageId');
    if (this.languageId && languageService.checkIsValideLanguage(this.languageId)) {
      this.isPageNotFound = false
    } else {
      this.isPageNotFound = true;
    }

    const anonymizeParticipantData = sessionStorage.getItem('anonymizeParticipant');
    if (anonymizeParticipantData) {
      this.participantDataToAnonymize = anonymizeParticipantData;
    }

  }

  ngOnInit(): void {
    this.setVideoSource();
    this.language = this.languageService.getLanguage();
    const featureFlag = this.translationService.featureFlags;
    this.isProd = featureFlag?.general.tempProdFlag;

    this.currentUser = this.awsAuth.getUserLoggedInStatus();
    // for prod environment, show the landing page
    // for non prod environment, if user is logged in, redirect to explore page
    // if (!this.isProd && this.currentUser) {
    //   this.goToExplore();
    // }
  }



  triggerLogin() {
    this.awsAuth.signIn();
    this.logstatus = true
  }

  closeAnonymizationPopup(_status: boolean) {
    this.participantDataToAnonymize = undefined;

  }


  @HostListener('window:resize')
  onResize() {
    this.setVideoSource();
  }

  setVideoSource() {
    const width = window.innerWidth;
    this.bgVideoClass = width > 1080 ? 'landscape' : 'portrait';

    this.videoSrc = width > 1080
      ? '../../../assets/media/landscape-stories.mp4'
      : '../../../assets/media/portrait-stories.mp4';
  }


}
